import React from 'react'
import parser from 'html-react-parser'
import classNames from 'classnames';
import {
    videoContent

} from './Video3.module.css';
export default function Video3({data}) {
    const {video3ButtonEmail, video3ButtonText, video3Text, video3Title, video3Url, video3BottomText, video3ReverseRow} = data
    return (
        <div className='join-our-movment-wrap panel-space-70 team-ceo-sec'>
            <div className='container'>
                
                <div className={classNames('row v-center mb-4', video3ReverseRow)}>
                    <div className='col-md-6'>
                        <div className=' hide-mobile'>
                            <iframe
                                src={video3Url}
                                title='Ceo Video'
                                width='640'
                                height='360'
                                allow='autoplay; fullscreen; picture-in-picture'
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                    <div className={classNames('col-md-6 team-content-col', videoContent)}>
                        <h2 className='heading-level-2 blue-color'>{video3Title && parser(video3Title)}</h2>
                        <div className='hide-desk'>
                            <iframe
                                src={video3Url}
                                title='Ceo mobile video'
                                width='640'
                                height='360'
                                allow='autoplay; fullscreen; picture-in-picture'
                                allowFullScreen
                            ></iframe>
                        </div>
                        <p>{video3Text && parser(video3Text)}</p>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <p>{video3BottomText && parser(video3BottomText)}</p>

                        <div className='text-center'>
                            {video3ButtonEmail && (
                                <a
                                    href={`mailto:${video3ButtonEmail}`}
                                    className='btn blue-btn'
                                >
                                    {video3ButtonText}
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
